export default __webpack_public_path__ + "static/media/no-image.3656b733.png";